import React, { useState, useEffect } from "react";
import { menu, arrowDown } from "../assets";

const sections = [
    { id: 'about', title: 'About' },
    { id: 'projects', title: 'Projects' },
    { id: 'publications', title: 'Publications' },
    { id: 'modeling', title: '3D Modeling' },
    { id: 'contact', title: 'Contact' }
];

const NavBar = () => {
    const [activeSection, setActiveSection] = useState('');
    const [isNavOpen, setIsNavOpen] = useState(false)

    const scrollTo = (id) => {
        const section = document.getElementById(id);
        if (!section) return;
        if (id === 'about'){
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
            section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        setActiveSection(id);
        setIsNavOpen(false);
    };

    useEffect(() => {
        const handleScroll = () => {
            let currentSection = '';
            sections.forEach((section) => {
                const item = document.getElementById(section.id);
                if (item) {
                    const rect = item.getBoundingClientRect();
                    if (rect.top <= window.innerHeight / 2 && rect.bottom >= window.innerHeight / 2) {
                        currentSection = section.id;
                    }
                }

            });
            setActiveSection(currentSection);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <>
            <div className={`burger-menu ${isNavOpen ? 'open' : ''}`} onClick={() => setIsNavOpen(!isNavOpen)}>
                <h3>{activeSection.charAt(0).toUpperCase() + activeSection.slice(1)}</h3>
                <img src={menu.src} alt={menu.alt} />
            </div>
            <nav className={`navBar ${isNavOpen ? 'open' : ''}`}>
                {sections.map((section) => (
                    <a
                        key={section.id}
                        className={`navButton ${activeSection === section.id ? 'active' : ''}`}
                        onClick={() => scrollTo(section.id)}
                    >
                        {section.title}
                    </a>
                ))}
            </nav>
        </>
    );
};

export default NavBar;